import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import AddBuyerModal from './AddBuyerModal';
import { apiClient } from '../../../components/api/ApiClient';

const buyerTypeOptions = [
    { value: 1, label: 'حقیقی' },
    { value: 2, label: 'حقوقی' },
    { value: 3, label: 'مشارکت مدنی' },
    { value: 4, label: 'اتباع غیر ایرانی' },
];

const flightTypeOptions = [
    { value: 1, label: 'داخلی' },
    { value: 2, label: 'خارجی' },
];

const ladingBillTypeOptions = [
    { value: 1, label: 'ریلی' },
    { value: 2, label: 'جاده‌ای' },
    { value: 3, label: 'هوایی' },
    { value: 4, label: 'دریایی' },
];

function BuyerInfoStep({ formData, onDataChange, setShowBuyerModal, showBuyerModal, readOnly, mode, isShow = () => true, isRequired = () => false, ...rest }) {
    const [availableBuyers, setAvailableBuyers] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const API_ENDPOINT = '/user-preferences/api/user-person';

        const fetchBuyers = async () => {
            setIsLoading(true);
            setError(null);
            try {
                const data = await apiClient(API_ENDPOINT)
                setAvailableBuyers(data);
            } catch (err) {
                const errorMessage = err.message || "خطا در بارگذاری لیست خریداران.";
                setError(errorMessage);
                setAvailableBuyers([]);
            } finally {
                setIsLoading(false);
            }
        };

        fetchBuyers();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        
        if (name === 'personId' && mode === 'edit') {
            onDataChange({ 
                buyerId: value,
                buyerNationalCode: value,
                personId: value
            });
        } else {
            onDataChange({ [name]: value });
        }
    };


    const handleSelectUserProfPerson = (item) => {
        // Prioritize UUID if available, otherwise use other identifiers
        const buyerId = String(item.UUID || item.uuid || item.personId || item.buyerId || '');
        const buyerName = item.name 
            ? `${item.name} ${item.lastName || ''}`.trim() 
            : item.companyName || '';
        onDataChange({
            buyerId: buyerId || String(item.personId || item.nationalCode || item.economicCode || ''),
            buyerName: buyerName,
            buyerType: parseInt(item.personType) || 1,
            buyerPostalCode: item.personPostalCode || item.postalCode || '',
            buyerEconomicNum: item.personEconomicNum || item.economicCode || '',
            buyerBranchNum: item.branchNum || item.branchCode || '',
            buyerBranchName: item.branchName || '',
            buyerAvailable: mode === 'edit',
            personId: item.personId || item.nationalCode || ''
        });
    };

    const handleAddBuyer = async (newBuyer) => {
        try {
            const API_ENDPOINT = '/user-preferences/api/user-person';
            const data = await apiClient(API_ENDPOINT);
            setAvailableBuyers(data);
            
            const addedBuyer = Array.isArray(data) ? data.find(b => 
                String(b.UUID || b.uuid || b.id || '') === String(newBuyer.UUID || newBuyer.uuid || newBuyer.id || '') ||
                String(b.personId || b.nationalCode || '') === String(newBuyer.personId || newBuyer.nationalCode || '')
            ) : null;
            
            if (addedBuyer) {
                const newId = String(addedBuyer.UUID || addedBuyer.uuid || addedBuyer.id || addedBuyer.buyerId || addedBuyer.personId || addedBuyer.nationalCode || addedBuyer.economicCode || '');
                onDataChange({
                    buyerId: newId,
                    buyerName: addedBuyer.companyName || `${addedBuyer.name || ''} ${addedBuyer.lastName || ''}`.trim(),
                    buyerEconomicNum: addedBuyer.personEconomicNum || addedBuyer.economicCode || '',
                    buyerPostalCode: addedBuyer.personPostalCode || addedBuyer.postalCode || '',
                    buyerBranchNum: addedBuyer.branchNum || addedBuyer.branchCode || '',
                    buyerBranchName: addedBuyer.branchName || '',
                    buyerType: addedBuyer.personType || 1,
                    buyerAvailable: mode === 'edit',
                    personId: addedBuyer.personId || addedBuyer.nationalCode || ''
                });
            }
        } catch (err) {
            console.error('Error refreshing buyer list:', err);
        }
    };

    const buyerType = parseInt(formData.buyerType) || 1;

    const getPersonIdFromBuyer = () => {
        if (!formData.buyerId) return '';
        const selectedBuyer = availableBuyers.find(
            b => String(b.buyerNationalCode || b.UUID || b.uuid || b.id || b.buyerId || b.personId || b.nationalCode || b.economicCode || '') === String(formData.buyerId)
        );
        return selectedBuyer?.personId || selectedBuyer?.nationalCode || '';
    };

    return (
        <div className="step-content">
            <h5 className="mb-4">اطلاعات اولیه خریدار</h5>
            <div className="row">

                <div className="col-md-6 mb-3">
                    <label htmlFor="buyerName" className="form-label">
                        نام و نام خانوادگی / نام شرکت
                    </label>
                    <div className="input-group">
                        {(() => {
                            let buyersToShow = availableBuyers;
                            
                            if (mode === 'edit') {
                                const fId = String(formData.buyerId || '').trim();
                                const fPId = String(formData.personId || '').trim();

                                if (fId || fPId) {
                                    const filtered = availableBuyers.filter(b => {
                                        const bId = String(b.UUID || b.uuid || b.id || b.buyerId || b.personId || b.nationalCode || b.economicCode || '').trim();
                                        const bNat = String(b.nationalCode || b.personId || '').trim();
                                        return (fId && bId === fId) || (fPId && bNat === fPId) || (fId && bNat === fId);
                                    });
                                    if (filtered.length > 0) {
                                        buyersToShow = filtered;
                                    }
                                }
                            }

                            const selectOptions = buyersToShow.map(item => ({
                                value: String(item.UUID || item.uuid || item.id || item.buyerId || item.personId || item.nationalCode || item.economicCode || ''),
                                label: item.name ? `${item.name} ${item.lastName || ''}`.trim() : item.companyName
                            }));
                            const selectedOption =
                                selectOptions.find(opt => opt.value === String(formData.buyerId || '')) ||
                                (formData.buyerName
                                    ? { value: String(formData.buyerId || ''), label: formData.buyerName }
                                    : null);

                                
                            return (
                                <Select
                                    className="react-select-container flex-grow-1"
                                    classNamePrefix="react-select"
                                    options={selectOptions}
                                    value={selectedOption}
                                    onChange={(selectedOption) => {
                                        if (selectedOption) {
                                            const selectedId = selectedOption.value;
                                            const selectedBuyer = availableBuyers.find(
                                                b => String(b.UUID || b.uuid || b.id || b.buyerId || b.personId || b.nationalCode || b.economicCode || '') === selectedId
                                            );
                                            if (selectedBuyer) {
                                                handleSelectUserProfPerson(selectedBuyer);
                                            }
                                        } else {
                                            onDataChange({
                                                buyerId: '',
                                                buyerName: '',
                                                buyerEconomicNum: '',
                                                buyerPostalCode: '',
                                                buyerBranchNum: '',
                                                buyerBranchName: '',
                                                buyerType: 1,
                                                personId: ''
                                            });
                                        }
                                    }}
                                    isDisabled={readOnly}
                                    isLoading={isLoading}
                                    isClearable={!readOnly}
                                    placeholder={isLoading ? "در حال بارگذاری..." : "جستجو و انتخاب خریدار..."}
                                    noOptionsMessage={() => "موردی یافت نشد"}
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            borderTopLeftRadius: 0,
                                            borderBottomLeftRadius: 0,
                                            height: '100%',
                                        })
                                    }}
                                />
                            );
                        })()}
                        {!readOnly && mode !== 'edit' && (
                            <button className="btn btn-primary" type="button" onClick={() => setShowBuyerModal(true)} style={{ zIndex: 0 }}>
                                <i className="feather-plus"></i>
                            </button>
                        )}
                    </div>
                </div>

                {isShow('buyerType') && (
                    <div className="col-md-6 mb-3">
                        <label htmlFor="buyerType" className="form-label">
                            نوع خریدار {isRequired('buyerType') && !readOnly && <span className="text-danger">*</span>}
                        </label>
                        <select
                            className="form-select"
                            id="buyerType"
                            name="buyerType"
                            value={buyerType}
                            onChange={handleChange}
                            required={isRequired('buyerType')}
                            disabled={readOnly}
                        >
                            {buyerTypeOptions.map(opt => (
                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                            ))}
                        </select>
                    </div>
                )}

                {isShow('flightType') && (
                    <div className="col-md-6 mb-3">
                        <label htmlFor="flightType" className="form-label">
                            نوع پرواز {isRequired('flightType') && !readOnly && <span className="text-danger">*</span>}
                        </label>
                        <select
                            className="form-select"
                            id="flightType"
                            name="flightType"
                            value={formData.flightType || ''}
                            onChange={handleChange}
                            disabled={readOnly}
                        >
                            <option value="">انتخاب کنید...</option>
                            {flightTypeOptions.map(opt => (
                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                            ))}
                        </select>
                    </div>
                )}

                {isShow('buyerBranchNum') && (
                    <>
                        <div className="col-md-6 mb-3">
                            <label htmlFor="buyerBranchNum" className="form-label">
                                کد شعبه خریدار {isRequired('buyerBranchNum') && !readOnly && <span className="text-danger">*</span>}
                            </label>
                            <input
                                type="number"
                                className="form-control"
                                id="buyerBranchNum"
                                name="buyerBranchNum"
                                value={formData.buyerBranchNum || ''}
                                onChange={handleChange}
                                disabled={readOnly}
                            />
                        </div>

                        <div className="col-md-6 mb-3">
                            <label htmlFor="buyerBranchName" className="form-label">
                                نام شعبه خریدار {isRequired('buyerBranchNum') && !readOnly && <span className="text-danger">*</span>}
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="buyerBranchName"
                                name="buyerBranchName"
                                value={formData.buyerBranchName || ''}
                                onChange={handleChange}
                                disabled={readOnly}
                            />
                        </div>
                    </>
                )}

                {isShow('buyerPassport') && (
                    <div className="col-md-6 mb-3">
                        <label htmlFor="buyerPassport" className="form-label">
                            شماره گذرنامه خریدار {isRequired('buyerPassport') && !readOnly && <span className="text-danger">*</span>}
                        </label>
                        <input
                            type="number"
                            className="form-control"
                            id="buyerPassport"
                            name="buyerPassport"
                            value={formData.buyerPassport || ''}
                            onChange={handleChange}
                            disabled={readOnly}
                        />
                    </div>
                )}

                {isShow('buyerType') && [2, 3].includes(buyerType) && (
                    <div className="col-md-6 mb-3">
                        <label htmlFor="buyerEconomicNum" className="form-label">
                            شماره اقتصادی خریدار {isRequired('buyerType') && !readOnly && <span className="text-danger">*</span>}
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            id="buyerEconomicNum"
                            name="buyerEconomicNum"
                            value={formData.buyerEconomicNum || ''}
                            onChange={handleChange}
                            required
                            disabled={readOnly}
                        />
                    </div>
                )}

                {isShow('buyerType') && [1, 4].includes(buyerType) && (
                    <>
                        <div className="col-md-6 mb-3">
                            <label htmlFor="buyerId" className="form-label">
                                {buyerType === 1
                                    ? "شناسنامه / کد ملی خریدار"
                                    : buyerType === 4
                                        ? "کد فراگیر اتباع غیر ایرانی خریدار"
                                        : "شناسنامه/کدملی/کد فراگیر اتباع غیر ایرانی خریدار"
                                } {isRequired('buyerType') && !readOnly && <span className="text-danger">*</span>}
                            </label>
                            <input
                                type="number"
                                className="form-control"
                                id="buyerId"
                                name="personId"
                                value={formData.buyerNationalCode || formData.personId || getPersonIdFromBuyer() || ''}
                                onChange={handleChange}
                                required
                                disabled={readOnly}
                            />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label htmlFor="buyerPostalCode" className="form-label">
                                کد پستی خریدار {isRequired('buyerType') && !readOnly && <span className="text-danger">*</span>}
                            </label>
                            <input
                                type="number"
                                className="form-control"
                                id="buyerPostalCode"
                                name="buyerPostalCode"
                                value={formData.buyerPostalCode || ''}
                                onChange={handleChange}
                                required
                                disabled={readOnly}
                            />
                        </div>
                    </>
                )}

                {isShow('economicAgencyNum') && (
                    <div className="col-md-6 mb-3">
                        <label htmlFor="economicAgencyNum" className="form-label">
                            شماره اقتصادی آژانس {isRequired('economicAgencyNum') && !readOnly && <span className="text-danger">*</span>}
                        </label>
                        <input
                            type="number"
                            className="form-control"
                            id="economicAgencyNum"
                            name="economicAgencyNum"
                            value={formData.economicAgencyNum || ''}
                            onChange={handleChange}
                            disabled={readOnly}
                        />
                    </div>
                )}

                {isShow('saleNoticeNum') && (
                    <div className="col-md-6 mb-3">
                        <label htmlFor="saleNoticeNum" className="form-label">
                            شماره اعلامیه فروش {isRequired('saleNoticeNum') && !readOnly && <span className="text-danger">*</span>}
                        </label>
                        <input
                            type="number"
                            className="form-control"
                            id="saleNoticeNum"
                            name="saleNoticeNum"
                            value={formData.saleNoticeNum || ''}
                            onChange={handleChange}
                            disabled={readOnly}
                        />
                    </div>
                )}

                {isShow('saleNoticeDate') && (
                    <div className="col-md-6 mb-3">
                        <label htmlFor="saleNoticeDate" className="form-label">
                            تاریخ اعلامیه فروش {isRequired('saleNoticeDate') && !readOnly && <span className="text-danger">*</span>}
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            id="saleNoticeDate"
                            name="saleNoticeDate"
                            value={formData.saleNoticeDate || ''}
                            onChange={handleChange}
                            placeholder="1402/01/01"
                            disabled={readOnly}
                        />
                    </div>
                )}

                {isShow('sellerContractId') && (
                    <div className="col-md-6 mb-3">
                        <label htmlFor="sellerContractId" className="form-label">
                            شناسه یکتای ثبت قرارداد فروشنده {isRequired('sellerContractId') && !readOnly && <span className="text-danger">*</span>}
                        </label>
                        <input
                            type="number"
                            className="form-control"
                            id="sellerContractId"
                            name="sellerContractId"
                            value={formData.sellerContractId || ''}
                            onChange={handleChange}
                            disabled={readOnly}
                        />
                    </div>
                )}

                {isShow('subId') && (
                    <div className="col-md-6 mb-3">
                        <label htmlFor="subId" className="form-label">
                            شماره اشتراک/شناسه قبض بهره بردار {isRequired('subId') && !readOnly && <span className="text-danger">*</span>}
                        </label>
                        <input
                            type="number"
                            className="form-control"
                            id="subId"
                            name="subId"
                            value={formData.subId || ''}
                            onChange={handleChange}
                            disabled={readOnly}
                        />
                    </div>
                )}

                {isShow('contractingNumber') && (
                    <div className="col-md-6 mb-3">
                        <label htmlFor="contractingNumber" className="form-label">
                            شماره قرارداد پیمانکاری {isRequired('contractingNumber') && !readOnly && <span className="text-danger">*</span>}
                        </label>
                        <input
                            type="number"
                            className="form-control"
                            id="contractingNumber"
                            name="contractingNumber"
                            value={formData.contractingNumber || ''}
                            onChange={handleChange}
                            disabled={readOnly}
                        />
                    </div>
                )}

                {isShow('customsLicenseNumber') && (
                    <div className="col-md-6 mb-3">
                        <label htmlFor="customsLicenseNumber" className="form-label">
                            شماره پروانه گمرکی {isRequired('customsLicenseNumber') && !readOnly && <span className="text-danger">*</span>}
                        </label>
                        <input
                            type="number"
                            className="form-control"
                            id="customsLicenseNumber"
                            name="customsLicenseNumber"
                            value={formData.customsLicenseNumber || ''}
                            onChange={handleChange}
                            disabled={readOnly}
                        />
                    </div>
                )}

                {isShow('customSellerCode') && (
                    <div className="col-md-6 mb-3">
                        <label htmlFor="customSellerCode" className="form-label">
                            کد گمرک محل اظهار فروشنده {isRequired('customSellerCode') && !readOnly && <span className="text-danger">*</span>}
                        </label>
                        <input
                            type="number"
                            className="form-control"
                            id="customSellerCode"
                            name="customSellerCode"
                            value={formData.customSellerCode || ''}
                            onChange={handleChange}
                            disabled={readOnly}
                        />
                    </div>
                )}

                {/* Transport / Lading Details */}
                {(isShow('ladingBill') || isShow('ladingBillType') || isShow('ladingBillNum') || isShow('originCountry') || isShow('originCity') || isShow('destinationCountry') || isShow('destinationCity') || isShow('senderNationalCode') || isShow('receiverNationalCode') || isShow('shippingNum') || isShow('driverNationalCode')) && (
                    <div className="col-12"><h6 className="mt-4 mb-3 text-muted fw-bold border-bottom pb-2">اطلاعات حمل و نقل و بارنامه</h6></div>
                )}

                {isShow('ladingBill') && (
                    <div className="col-md-6 mb-3">
                        <label htmlFor="ladingBill" className="form-label">
                            شماره سند حمل / شماره بارنامه {isRequired('ladingBill') && !readOnly && <span className="text-danger">*</span>}
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            id="ladingBill"
                            name="ladingBill"
                            value={formData.ladingBill || ''}
                            onChange={handleChange}
                            disabled={readOnly}
                        />
                    </div>
                )}

                {isShow('ladingBillType') && (
                    <div className="col-md-6 mb-3">
                        <label htmlFor="ladingBillType" className="form-label">
                            نوع انتقال {isRequired('ladingBillType') && !readOnly && <span className="text-danger">*</span>}
                        </label>
                        <select
                            className="form-select"
                            id="ladingBillType"
                            name="ladingBillType"
                            value={formData.ladingBillType || ''}
                            onChange={handleChange}
                            disabled={readOnly}
                        >
                            <option value="">انتخاب کنید...</option>
                            {ladingBillTypeOptions.map(opt => (
                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                            ))}
                        </select>
                    </div>
                )}

                {isShow('ladingBillNum') && (
                    <div className="col-md-6 mb-3">
                        <label htmlFor="ladingBillNum" className="form-label">
                            شماره بارنامه مرجع {isRequired('ladingBillNum') && !readOnly && <span className="text-danger">*</span>}
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            id="ladingBillNum"
                            name="ladingBillNum"
                            value={formData.ladingBillNum || ''}
                            onChange={handleChange}
                            disabled={readOnly}
                        />
                    </div>
                )}

                {isShow('originCountry') && (
                    <div className="col-md-6 mb-3">
                        <label htmlFor="originCountry" className="form-label">
                            کشور مبدا {isRequired('originCountry') && !readOnly && <span className="text-danger">*</span>}
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            id="originCountry"
                            name="originCountry"
                            value={formData.originCountry || ''}
                            onChange={handleChange}
                            disabled={readOnly}
                        />
                    </div>
                )}

                {isShow('originCity') && (
                    <div className="col-md-6 mb-3">
                        <label htmlFor="originCity" className="form-label">
                            شهر مبدا {isRequired('originCity') && !readOnly && <span className="text-danger">*</span>}
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            id="originCity"
                            name="originCity"
                            value={formData.originCity || ''}
                            onChange={handleChange}
                            disabled={readOnly}
                        />
                    </div>
                )}

                {isShow('destinationCountry') && (
                    <div className="col-md-6 mb-3">
                        <label htmlFor="destinationCountry" className="form-label">
                            کشور مقصد {isRequired('destinationCountry') && !readOnly && <span className="text-danger">*</span>}
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            id="destinationCountry"
                            name="destinationCountry"
                            value={formData.destinationCountry || ''}
                            onChange={handleChange}
                            disabled={readOnly}
                        />
                    </div>
                )}

                {isShow('destinationCity') && (
                    <div className="col-md-6 mb-3">
                        <label htmlFor="destinationCity" className="form-label">
                            شهر مقصد {isRequired('destinationCity') && !readOnly && <span className="text-danger">*</span>}
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            id="destinationCity"
                            name="destinationCity"
                            value={formData.destinationCity || ''}
                            onChange={handleChange}
                            disabled={readOnly}
                        />
                    </div>
                )}

                {isShow('senderNationalCode') && (
                    <div className="col-md-6 mb-3">
                        <label htmlFor="senderNationalCode" className="form-label">
                            شناسه ملی / شماره ملی فرستنده {isRequired('senderNationalCode') && !readOnly && <span className="text-danger">*</span>}
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            id="senderNationalCode"
                            name="senderNationalCode"
                            value={formData.senderNationalCode || ''}
                            onChange={handleChange}
                            disabled={readOnly}
                        />
                    </div>
                )}

                {isShow('receiverNationalCode') && (
                    <div className="col-md-6 mb-3">
                        <label htmlFor="receiverNationalCode" className="form-label">
                            شناسه ملی / شماره ملی گیرنده {isRequired('receiverNationalCode') && !readOnly && <span className="text-danger">*</span>}
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            id="receiverNationalCode"
                            name="receiverNationalCode"
                            value={formData.receiverNationalCode || ''}
                            onChange={handleChange}
                            disabled={readOnly}
                        />
                    </div>
                )}

                {isShow('shippingNum') && (
                    <div className="col-md-6 mb-3">
                        <label htmlFor="shippingNum" className="form-label">
                            شماره ناوگان {isRequired('shippingNum') && !readOnly && <span className="text-danger">*</span>}
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            id="shippingNum"
                            name="shippingNum"
                            value={formData.shippingNum || ''}
                            onChange={handleChange}
                            disabled={readOnly}
                        />
                    </div>
                )}

                {isShow('driverNationalCode') && (
                    <div className="col-md-6 mb-3">
                        <label htmlFor="driverNationalCode" className="form-label">
                            کد ملی راننده {isRequired('driverNationalCode') && !readOnly && <span className="text-danger">*</span>}
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            id="driverNationalCode"
                            name="driverNationalCode"
                            value={formData.driverNationalCode || ''}
                            onChange={handleChange}
                            disabled={readOnly}
                        />
                    </div>
                )}
            </div>

            <AddBuyerModal
                show={showBuyerModal}
                handleClose={() => setShowBuyerModal(false)}
                handleAddBuyer={handleAddBuyer}
            />
        </div>
    );
}

export default BuyerInfoStep;